var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLighthub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24999 21.7502H15.75M12.7594 5.32515C13.676 5.48054 14.5219 5.91663 15.1801 6.57321C15.8384 7.2298 16.2766 8.07452 16.4344 8.99078M7.37811 15.6564C6.48523 14.9621 5.76207 14.0738 5.26341 13.0586C4.76476 12.0434 4.50369 10.9281 4.49999 9.79703C4.48124 5.72828 7.75311 2.3439 11.8219 2.25015C13.3966 2.21283 14.943 2.67222 16.2419 3.56318C17.5409 4.45415 18.5263 5.73146 19.0585 7.21395C19.5907 8.69644 19.6427 10.3089 19.207 11.8225C18.7713 13.3362 17.8701 14.6743 16.6312 15.647C16.3576 15.8586 16.1359 16.1299 15.9831 16.4402C15.8304 16.7506 15.7507 17.0918 15.75 17.4377V18.0002C15.75 18.1991 15.671 18.3898 15.5303 18.5305C15.3897 18.6711 15.1989 18.7502 15 18.7502H8.99999C8.80108 18.7502 8.61031 18.6711 8.46966 18.5305C8.32901 18.3898 8.24999 18.1991 8.24999 18.0002V17.4377C8.24764 17.0944 8.16805 16.756 8.01712 16.4476C7.86619 16.1393 7.64779 15.8689 7.37811 15.6564Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthub);
export default __webpack_public_path__ + "static/media/lighthub.4dc6f7175d8d8484e381e56ba9f24203.svg";
export { ForwardRef as ReactComponent };